/**
 * Implements a trading box: balance, input, coin selector
 */
import Image from '../atoms/Image';
import Text from '../atoms/Text';
import SmallCurrencyIcon from '../components/Trading/common/SmallCurrencyIcon';
import arrow_down from '../assets/images/shevron_down.svg';
import DebounceInput from '../components/Trading/common/DebounceInput';
import BigNumber from 'bignumber.js';
import { Network } from '@kattana-io/common';

interface IProps {
  network: Network;
  title: string;
  estimation?: boolean;
  balance: string | number;
  coinTitle: string;
  coinAddress: string;
  value: BigNumber;
  // eslint-disable-next-line no-unused-vars
  onChange: (val: any) => void;
  setTab: () => void;
  disabled?: boolean;
  isCoinChangable: boolean;
}

const TradingBox = (props: IProps) => (
  <div
    className={`trading_box ${props.disabled ? 'trading_box--disabled' : ''} ${props.estimation ? 'trading_box--estimation' : ''}`}
    aria-label={props.title}
  >
    <div className='row balance_row'>
      <div className='direction' aria-label='Coin direction'>
        <Text size={12}>{props.title}</Text>
      </div>
      <div
        className='balance'
        aria-label='Amount of this coin'
        onClick={() => props.onChange(props.balance)}
      >
        <Text size={12} className='text--weight-500'>
          Balance:
        </Text>
        <Text size={12} className='text--grey-400'>
          &nbsp;{props.balance}
        </Text>
      </div>
    </div>
    <div className='row input_row'>
      <div
        className='coin_row'
        aria-label='Change coin'
        onClick={() => props.setTab()}
      >
        <SmallCurrencyIcon
          network={props.network}
          className='coin_row__icon'
          currency={props.coinTitle}
          contract={props.coinAddress}
          variant='s'
        />
        <Text
          className='coin_row__title'
          size={18}
          style={{ title: props.coinTitle }}
        >
          {props.coinTitle}
        </Text>
        <Image src={arrow_down} size='m' />
      </div>
      <DebounceInput
        value={props.value}
        onChange={props.onChange}
        className='input'
        disabled={props.disabled ?? false}
      />
    </div>
  </div>
);

export default TradingBox;
